import { Form } from 'rewire-ui';

export default function setViewOnlyForFormFields(form: Form, viewOnlyFn: () => boolean, viewOnlyAccessExceptionsFieldNames?: string[]) {
  let formFields = form.fields;
  formFields     = formFields.filter(f => f.type !== 'static' && !viewOnlyAccessExceptionsFieldNames?.includes(f.name));
  formFields.forEach(f => {
    const fieldDisabled = f.disabled;
    f.disabled = () => !!(viewOnlyFn() || fieldDisabled?.(f));
  });
}